export default function ErrorPage() {
  return (
    <div>
      <h1>Oops!</h1>
      <p>Sorry, page not found.</p>
    </div>
  );
}
